import { E2ETestUsers, SyntheticUsers } from '../common';

export const isTestUser = (email: string): boolean =>
  [...SyntheticUsers, ...E2ETestUsers].findIndex(e => e.toLowerCase() === email.toLowerCase()) !== -1;
